module.exports = __webpack_public_path__ + "media/fallback/student-deals-11653a36.png";